module.exports = __webpack_public_path__ + "static/logo-grey-5f742fbd1938f916db9026550771bc64.png";